import type { GeoEntry } from "../../types/analytics";
import styles from "./GeoTable.module.css";

interface GeoTableProps {
  data: GeoEntry[];
}

export function GeoTable({ data }: GeoTableProps) {
  if (data.length === 0) {
    return <div className={styles.empty}>No geographic data</div>;
  }

  const total = data.reduce((sum, e) => sum + e.count, 0);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Geographic Distribution</h3>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Country</th>
            <th>Region</th>
            <th>Events</th>
            <th>Share</th>
          </tr>
        </thead>
        <tbody>
          {data.slice(0, 20).map((entry, i) => (
            <tr key={i}>
              <td>{entry.countryCode}</td>
              <td>{entry.region ?? "—"}</td>
              <td>{entry.count.toLocaleString()}</td>
              <td>{total > 0 ? `${((entry.count / total) * 100).toFixed(1)}%` : "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {data.length > 20 && <p className={styles.more}>Showing top 20 of {data.length} regions</p>}
    </div>
  );
}
